import { PropsWithChildren } from 'react';

import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme({
  spacing: 4,
  palette: {
    text: {
      primary: '#171324',
      secondary: '#F3C502',
    },
    background: {
      default: '#F1F1FA',
      paper: '#fff',
    },
  },
  customColors: {
    main: '#261834',

    additional700: '#15AEB7',

    white: '#FFF',

    dark: '#160F2B',

    gray50: '#94A3B8',

    black: '#151524',
    black10: '#D5D1E2',
    black20: '#F1F1FA',
    black30: '#898499',
    black50: '#635D73',
    black70: '#413E49',

    red: '#F66789',
    red10: '#FFEFF2',
    red20: '#FFE8EC',
    red90: '#F60740',
    red100: '#A50229',

    neutral200: '#E8E8E9',
    neutral300: '#D0D0D3',
    neutral400: '#AFB2B7',
    neutral500: '#A2B5BB',
    neutral600: '#8F9CA0',
    neutral602: '#5B5B66',

    primary10: '#E1D6FF',
    primary20: '#CBB9FF',
    primary30: '#BAA2FF',
    primary50: '#A07FFF',
    primary70: '#906DF1',
    primary80: '#8961F9',
    primary90: '#7D50FD',
    primary100: '#6934FF',
    primary200: '#FFF6DA',
    primary700: '#FFD747',

    success50: '#E8FFFB',
    success700: '#09BA9A',

    failure50: '#FFD4DC',
    failure700: '#7C1117',

    danger100: '#FEF2F2',
    danger700: '#EC2D30',

    info200: '#E4F2FF',
    info700: '#3A70E2',

    menuItem: '#E9E4F6',

    purple80: '#8961F9',

    green: '#9FF79D',
    green60: '#83FF80',
    green80: '#37BB34',
    green90: '#12920F',
    green100: '#084B37',

    orange100: '#E55300',
  },
  customShadows: {
    smallDetailsShadow: '0 8px 12px 0 rgba(19, 27, 67, 0.06)',
  },
  typography: {
    fontFamily: 'Tilda Sans, sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          width: '100%',
          height: '100%',
        },
        body: {
          width: '100%',
          height: '100%',
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '8px',
          backgroundColor: '#FFD747',
          color: '#151524',
          textAlign: 'center',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '20px',
          textTransform: 'none',
        },
        text: {
          textAlign: 'center',
          fontWeight: 400,
          color: '#898499',
          backgroundColor: 'transparent',
          lineHeight: '120%',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        vertical: {
          marginRight: 10,
          marginLeft: 10,
        },
        middle: {
          marginTop: 10,
          marginBottom: 10,
          width: '80%',
        },
      },
    },
  },
});

function AppThemeProvider({ children }: PropsWithChildren) {
  return <ThemeProvider theme={createTheme(theme)}>{children}</ThemeProvider>;
}

export default AppThemeProvider;
